import React from 'react';
import ReactDOM from 'react-dom/client';
import Swal from 'sweetalert2';

import './fonts.css';
import './index.css';
import './global.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

// Override default window.alert with SweetAlert2
window.alert = (message) => {
  Swal.fire({
    text: message,
    icon: 'success',
    confirmButtonText: 'OK',
    confirmButtonColor: '#28a745',
    customClass: {
      popup: 'swal2-centered'
    }
  });
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();